<template>
    <div class="tCenteredArea_Easy">
        <div id="tReels_Easy" class="">
            <div id="popular_users_Easy">
                <Tabs value="0" scrollable>
                    <div class="popular_user_header">
                        <h4>{{ $t('reels.popular') }}</h4> 
                        <Button :label="$t('reels.manage')" icon="pi pi-upload"
                            size="small" severity="contrast" @click="openManageReels()" />
                    </div>


                    <TabList class="popular_user_tabs_Easy">
                        <Tab v-for="user in popular_users" :key="user.id" :value="user.id.toString()"
                            class="popular_user_Easy">
                            <span class="avatar__story-border avatar__story-border--active"></span>
                            <span :style="{ 'background-image': `url(${$utils.getAvatar(user.avatar)})` }"
                                class="popular_user_avatar_Easy" />
                            <p class="popular_user_nickname_Easy">{{ user.nickname }}</p>
                        </Tab>
                    </TabList>
                </Tabs>
            </div>
            <div id="reels-container_Easy">
                <Tabs value="0">
                    <TabList>
                        <Tab v-for="tab in tabs" :key="tab.title" :value="tab.value" @click="onTabChange(tab.value)">{{
                            tab.title }}</Tab>
                    </TabList>
                </Tabs>

                <Card v-for="reel in reels_list" :key="reel.id" class="reels">

                    <template #content>
                        <div class="reel_header mb-2">
                            <Avatar :label="reel.nickname.charAt(0).toUpperCase()" size="large"
                                :style="getAvatarStyle(reel.gender)" shape="circle" v-if="!reel.avatar" />
                            <Avatar :image="$utils.getAvatar(reel.avatar)" shape="circle" size="large" v-else />
                            <div>
                                <h4 class="reel_nickname">{{ reel.nickname }}</h4>
                                <p class="reel_date">{{ calculateTimeAgo(reel.created_at) }}</p>
                            </div>
                            <i class="reel_action_icon pi pi-times" @click.stop="openMenu($event, reel.id)"></i>
                        </div>
                        <div class="reel_content">

                            <Galleria :value="reel.contents" :responsiveOptions="responsiveOptions" :numVisible="5"
                                containerStyle="width: 100%" thumbnailsPosition="right"
                                :showThumbnails="reel.contents.length > 1">
                                <template #item="slotProps">

                                    <div v-if="slotProps.item.isVideo" style="height: 100%; max-height: 640px;">
                                        <video controls :src="getItemUrl(slotProps.item)"
                                            style="width: 100%; display: block"></video>
                                        <div class="image-locked" v-if="slotProps.item.token != 0 && !isBought(slotProps.item._id)">
                                            <i class="pi pi-lock"></i>
                                            <Button
                                                :label="'Use ' + slotProps.item.token + ' Tokens to view full version of video'"
                                                severity="danger" size="small" @click="buyContent(slotProps.item)" />
                                        </div>
                                    </div>
                                    <div v-else style="height: 100%; max-height: 640px;">
                                        <Image :src="getItemUrl(slotProps.item)" alt="Image" width="100%"
                                            class="image-display" />
                                        <div class="image-locked" v-if="slotProps.item.token != 0 && !isBought(slotProps.item._id)">
                                            <i class="pi pi-lock"></i>
                                            <Button :label="'Use ' + slotProps.item.token + ' Tokens to view'"
                                                severity="danger" size="small" @click="buyContent(slotProps.item)" />
                                        </div>
                                    </div>
                                </template>
                                <template #thumbnail="slotProps">
                                    <div class="grid gap-4 justify-center">
                                        <i class="pi pi-lock preview_locked" v-if="slotProps.item.token != 0 && !isBought(slotProps.item._id)"></i>
                                        <img :src="slotProps.item.isVideo ? slotProps.item.preview_url : slotProps.item.url"
                                            style="width: 80px; display: block;" />
                                    </div>
                                </template>
                            </Galleria>


                        </div>
                        <div class="reel_description" v-html="reel.post_messages"></div>
                        <div class="reel_footer">
                            <Button :label="(reel.views + 1).toString()" icon="pi pi-eye" severity="secondary"
                                size="small" raise />
                            <Button :label="reel.likes.toString()" icon="pi pi-heart" severity="secondary" size="small"
                                raise @click="like(reel)" />
                            <Button :label="$t('reels.message')" icon="pi pi-send" severity="secondary" size="small"
                                raise @click="sendMesssage(reel)" />
                            <Button :label="$t('reels.gift')" icon="pi pi-gift" severity="secondary" size="small"
                                @click="sendGift(reel)" />
                        </div>
                    </template>
                </Card>

                <h2 class="text-center" v-if="reels_list.length == 0">{{ $t('reels.no_reels') }}</h2>

                <Button :label="$t('reels.load_more')" size="small" class="m-auto mb-4" @click="loadReels" v-if="showLoadMore"
                    severity="secondary" />

            </div>
            <Menu :model="reelsMenuItems" :popup="true" ref="reelsMenu" />
        </div>


    </div>

</template>

<script>
import { ref } from 'vue';

export default {
    name: 'Reels',
    emits: ['selectMenu'],
    props: ['reels', 'boughtContents', 'popular_users'],
    setup() {
        const reelsMenu = ref(null);
        const togglereelsMenu = (event) => {
            if (reelsMenu.value) {
                reelsMenu.value.toggle(event);
            }
        };
        return { reelsMenu, togglereelsMenu };
    },
    data() {
        return {
            seledtedReel: 0,
            showLoadMore: false,
            reelTabs: '0',
            tabs: [
                { value: '0', title: this.$t('reels.new') },
                { value: '1', title: this.$t('reels.trend') },
                { value: '2', title: this.$t('reels.top') },
            ],
            reels_list: [

            ],
            reelsMenuItems: [
                {
                    label: this.$t('reels.report'),
                    icon: 'pi pi-fw pi-hammer',
                    command: () => {

                    }
                },
                {
                    label: this.$t('reels.link'),
                    icon: 'pi pi-fw pi-share-alt',
                    command: () => {

                    }
                }
            ],
            responsiveOptions: [
                {
                    breakpoint: '1300px',
                    numVisible: 4
                },
                {
                    breakpoint: '575px',
                    numVisible: 1
                }
            ]
        };
    },

    computed: {
        isBought() {
            return (contentId) => {
                const id = contentId.toString();
                return this.boughtContents.findIndex(content => content.content_id == id) != -1
            };
        }
    },
    methods: {
        openMenu(event, id) {
            this.seledtedReel = id;
            this.togglereelsMenu(event);
        },
        loadReels() {
            if (this.reelTabs == '0') {
                this.$socket.emit('getReels', { order: 'recent', limit: 10, offset: this.reels_list.length });
            } else if (this.reelTabs == '1') {
                this.$socket.emit('getReels', { order: 'likes', limit: 10, offset: this.reels_list.length });
            } else if (this.reelTabs == '2') {
                this.$socket.emit('getReels', { order: 'views', limit: 10, offset: this.reels_list.length });
            }
        },
        openManageReels() {
            this.$emit('selectMenu', { action: 'open-manage-reels' });
        },
        sendMesssage(user) {
            this.$emit('selectMenu', { action: 'message', user: { user_id: user.user_id, nickname: user.nickname, avatar: user.avatar } });
        },
        sendGift(user) {
            this.$emit('selectMenu', { action: 'gift', user: { user_id: user.user_id, nickname: user.nickname, avatar: user.avatar } });
        },
        like(reel) {
            this.$socket.emit('likeReels', reel.id);
        },
        onTabChange(value) {
            this.reelTabs = value;
            this.reels_list = [];
            if (value == '0') {
                this.$socket.emit('getReels', { order: 'recent', limit: 10, offset: 0 });
            } else if (value == '1') {
                this.$socket.emit('getReels', { order: 'likes', limit: 10, offset: 0 });
            } else if (value == '2') {
                this.$socket.emit('getReels', { order: 'views', limit: 10, offset: 0 });
            }
        },
        calculateTimeAgo(created_at) {
            const postDate = new Date(created_at);
            const currentDate = new Date();

            const diffInMs = currentDate - postDate;

            const diffInSeconds = Math.floor(diffInMs / 1000);
            const diffInMinutes = Math.floor(diffInSeconds / 60);
            const diffInHours = Math.floor(diffInMinutes / 60);
            const diffInDays = Math.floor(diffInHours / 24);

            if (diffInDays > 7) {
                return postDate.toLocaleDateString();
            } else if (diffInSeconds < 60) {
                return `${diffInSeconds}` + this.$t('times.seconds_ago');
            } else if (diffInMinutes < 60) {
                return `${diffInMinutes}` + this.$t('times.minutes_ago')
            } else if (diffInHours < 24) {
                return `${diffInHours} ` + this.$t('times.hours_ago')
            } else {
                return `${diffInDays} ` + this.$t('times.days_ago')
            }
        },
        buyContent(item) {

            this.$confirm.require({
                message: 'Are you sure you want to but this content with ' + item.token + ' gold?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Cancel',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Buy',
                    severity: 'contrast',
                },
                accept: () => {
                   return this.$socket.emit('buyContent', {id: item._id});
                },
                reject: () => {
                    return false
                }
            });

        },
        getItemUrl(item) {
            if (item.token != 0 && this.isBought(item._id)) {
                const selected_token = this.boughtContents.find(content => content.content_id == item._id);
                return `${item.url}?token=${selected_token.token}`;
            }
            return item.url;
        },

    },
    mounted() {

        this.$socket.on('update-reels', (data) => {

            if (data && data.length > 0) {
                this.showLoadMore = true;
            } else {
                this.showLoadMore = false;
            }

            if (data) {
                data.forEach(reel => {

                    reel.contents = reel.contents.map(file => {
                        return {
                            ...file,
                            token: parseInt(file.tokens),
                            isVideo: file.type,
                            url: this.$socket_url + '/viewReels/' + file.url,
                            preview_url: this.$socket_url + '/previewReels/' + file.url
                        };
                    });
                    this.reels_list.push(reel);

                })
            }
        });

        
        this.$socket.emit('getReels', { order: 'recent', limit: 10, offset: 0 });
    },
    unmounted() {
        this.$socket.off('update-reels');
    },
};  
</script>
<style scoped>
.reels {
    margin-bottom: 40px;
}

p.popular_user_nickname_Easy {
    position: absolute;
    bottom: 0;
    margin: 0;
    width: 65px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
    font-size: 12px;
    background: #8484843b;
}

.popular_user_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.popular_user_Easy {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-height: 92px;
    min-width: 92px;
    overflow: hidden;
    padding: 6px 0;
    position: relative;
    width: 92px;
    border-radius: 30.75%;
}

.avatar__story-border {
    background: #5f5f67;
    border-radius: 33.75%;
    bottom: 0%;
    left: 0%;
    overflow: hidden;
    position: absolute;
    right: 0%;
    top: 0%;
}

.reel_footer {
    display: flex;
    gap: 10px;
}

.avatar__story-border::before {
    background: #050506;
    border-radius: 32.75%;
    bottom: 1px;
    content: "";
    left: 1px;
    position: absolute;
    right: 1px;
    top: 1px;
}

.avatar__story-border--active::before {
    bottom: max(2.5%, 2px);
    left: max(2.5%, 2px);
    right: max(2.5%, 2px);
    top: max(2.5%, 2px);
}

.avatar__story-border--active {
    background: linear-gradient(225deg, #8a17fc 14.64%, #fc17fc 37.98%, #fcc217 85.36%);
}

.popular_user_avatar_Easy {
    background-position: center top;
    align-items: center;
    background-color: #201e1e;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    left: 4px;
    position: absolute;
    top: 3px;
    height: 84px;
    width: 84px;
}

.reel_header {
    display: flex;
}

.reel_header .p-avatar {
    margin-right: 10px;
}

.reel_nickname,
.reel_date {
    margin: 0;
}

#reels-container_Easy,
#popular_users_Easy {
    display: flex;
    max-width: 742px;
    flex-direction: column;
    margin: auto
}

.reel_action_icon {
    cursor: pointer;
    font-size: 18px;
    margin-left: auto;
    margin-right: 10px;
}

.reel_image {
    width: 100%;
    border-radius: 25px;
    margin-top: 10px;

}

.tCenteredArea_Easy {
    overflow: auto;
    height: 100%;
    max-width: 100%;
}

.image-locked {
    position: absolute;
    z-index: 5;
    top: calc(50% - 16px);
    height: 69px;
    display: flex;
    flex-direction: column;
    width: 300px;
    left: calc(50% - 150px);
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.image-locked i {
    font-size: 36px;
}
</style>